export default __webpack_public_path__ + "static/media/Email.cd042a09.svg";